export const rotaSemObra = [

    {
        path: '/materiais/template',
        name: 'Configurar templates',
        component: () => import("@/views/Materiais/ConfigurarTemplateMateriais.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Configurar Templates',
            title: "Configurar Templates",
            icon: 'mdi-file-document-edit',
            subject: ['Materiais'],
            action: ['manage'],
            showMenu: true,
            grupo: "Materiais",
            grupoTitle: "Materiais"
        },
    },
];

export const rotaComObra = [
    {
        path: '/:obra/materiais/novo',
        name: 'Nova lista de materiais',
        component: () => import("@/views/Materiais/NovaListaMateriais.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Materiais | Nova Lista',
            title: "Configurar Lista",
            icon: 'mdi-file-cog',
            subject: ['Materiais'],
            showMenu: false,
            grupo: "Materiais",
            grupoTitle: "Materiais"
        },
    },
    {
        path: '/obras/:obra/materiais',
        name: 'Lista de materiais obra',
        component: () => import("@/views/Materiais/ListaMateriais.vue"),
        meta: {
            obraObrigatoria: true,
            breadcrumb: 'Materiais',
            title: "Materiais",
            icon: 'mdi-file-document-outline',
            subject: ['Materiais'],
            showMenu: true,
            grupo: "Materiais",
            grupoTitle: "Materiais"
        },
    },
];
export const rotaDeFabricacao = [
    {
        path: '/fabricacao/:obra/materiais',
        name: 'Lista de materiais fabrica',
        component: () => import("@/views/Materiais/ListaMateriais.vue"),
        meta: {
            isRotaFabricacao: true,
            obraObrigatoria: true,
            breadcrumb: 'Materiais',
            title: "Materiais",
            icon: 'mdi-file-document-outline',
            subject: ['Materiais'],
            showMenu: true,
            grupo: "Materiais",
            grupoTitle: "Materiais"
        },
    },
];